<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' }">
    <div class="flex flex-col items-center">
      <img class="w-full my-10" src="@/assets/logo.png" />
    </div>
  </header>

</template>
